// @ts-nocheck

import type { Option, QrCodeSettings } from '@branchjs/neo-components';

import type { IQuickLink } from '../../../../../shared/types';
import type { ActionNamespaceConstants } from '../../../redux/types';
import type { QuickLinkCreatorReducerType } from '../../reducers/QuickLinkCreatorReducer/types/QuickLinkCreatorReducerType';
import type { Redirect } from '../../screens/ScreenLinkHubQuickLinkCreator/steps/RedirectsStep/Redirects.types';
import { QuickLinkCreatorService } from '../../services/QuickLinkCreatorService/QuickLinkCreatorService';
import { QuickLinkEditorService } from '../../services/QuickLinkEditorService/QuickLinkEditorService';
import dash_api from '../../support/dash_api';
import server from '../../support/server';
import { ReduxAsyncAction } from '../../support/utils';
import type { IQuickLinkTemplate } from '../../types/linkTypes';
import NotificationActions from '../NotificationActions';

const CLEAR_QUICK_LINK_NAMESPACE = 'CLEAR_QUICK_LINK' as const;
const ClearQuickLink = new ReduxAsyncAction(CLEAR_QUICK_LINK_NAMESPACE);
ClearQuickLink.registerRequest(async () => {
  return {};
});

export const CLEAR_QUICK_LINK: ActionNamespaceConstants<typeof CLEAR_QUICK_LINK_NAMESPACE> = ClearQuickLink.constants;
export const clearQuickLink = ClearQuickLink.request;

const UPDATE_IS_GENERAL_STEP_VISITED_NAMESPACE = 'UPDATE_IS_GENERAL_STEP_VISITED' as const;
const UpdateIsGeneralStepVisited = new ReduxAsyncAction(UPDATE_IS_GENERAL_STEP_VISITED_NAMESPACE);
UpdateIsGeneralStepVisited.registerRequest(async (isGeneralStepVisited: boolean) => {
  return { isGeneralStepVisited };
});

export const UPDATE_IS_GENERAL_STEP_VISITED: ActionNamespaceConstants<typeof UPDATE_IS_GENERAL_STEP_VISITED_NAMESPACE> =
  UpdateIsGeneralStepVisited.constants;
export const updateIsGeneralStepVisited = UpdateIsGeneralStepVisited.request;

const UPDATE_IS_ANALYTICS_TAGS_STEP_VISITED_NAMESPACE = 'UPDATE_IS_ANALYTICS_TAGS_STEP_VISITED' as const;
const UpdateIsAnalyticsTagsStepVisited = new ReduxAsyncAction(UPDATE_IS_ANALYTICS_TAGS_STEP_VISITED_NAMESPACE);
UpdateIsAnalyticsTagsStepVisited.registerRequest(async (isAnalyticsTagsStepVisited: boolean) => {
  return { isAnalyticsTagsStepVisited };
});

export const UPDATE_IS_ANALYTICS_TAGS_STEP_VISITED: ActionNamespaceConstants<
  typeof UPDATE_IS_ANALYTICS_TAGS_STEP_VISITED_NAMESPACE
> = UpdateIsAnalyticsTagsStepVisited.constants;
export const updateIsAnalyticsTagsStepVisited = UpdateIsAnalyticsTagsStepVisited.request;

const UPDATE_IS_REDIRECTS_STEP_VISITED_NAMESPACE = 'UPDATE_IS_REDIRECTS_STEP_VISITED' as const;
const UpdateIsRedirectsStepVisited = new ReduxAsyncAction(UPDATE_IS_REDIRECTS_STEP_VISITED_NAMESPACE);
UpdateIsRedirectsStepVisited.registerRequest(async (isRedirectsStepVisited: boolean) => {
  return { isRedirectsStepVisited };
});

export const UPDATE_IS_REDIRECTS_STEP_VISITED: ActionNamespaceConstants<typeof UPDATE_IS_REDIRECTS_STEP_VISITED_NAMESPACE> =
  UpdateIsRedirectsStepVisited.constants;
export const updateIsRedirectsStepVisited = UpdateIsRedirectsStepVisited.request;

const UPDATE_IS_LINK_DATA_STEP_VISITED_NAMESPACE = 'UPDATE_IS_LINK_DATA_STEP_VISITED' as const;
const UpdateIsLinkDataStepVisited = new ReduxAsyncAction(UPDATE_IS_LINK_DATA_STEP_VISITED_NAMESPACE);
UpdateIsLinkDataStepVisited.registerRequest(async (isLinkDataStepVisited: boolean) => {
  return { isLinkDataStepVisited };
});

export const UPDATE_IS_LINK_DATA_STEP_VISITED: ActionNamespaceConstants<typeof UPDATE_IS_LINK_DATA_STEP_VISITED_NAMESPACE> =
  UpdateIsLinkDataStepVisited.constants;
export const updateIsLinkDataStepVisited = UpdateIsLinkDataStepVisited.request;

const UPDATE_IS_SOCIAL_MEDIA_STEP_VISITED_NAMESPACE = 'UPDATE_IS_SOCIAL_MEDIA_STEP_VISITED' as const;
const UpdateIsSocialMediaStepVisited = new ReduxAsyncAction(UPDATE_IS_SOCIAL_MEDIA_STEP_VISITED_NAMESPACE);
UpdateIsSocialMediaStepVisited.registerRequest(async (isSocialMediaStepVisited: boolean) => {
  return { isSocialMediaStepVisited };
});

export const UPDATE_IS_SOCIAL_MEDIA_STEP_VISITED: ActionNamespaceConstants<
  typeof UPDATE_IS_SOCIAL_MEDIA_STEP_VISITED_NAMESPACE
> = UpdateIsSocialMediaStepVisited.constants;
export const updateIsSocialMediaStepVisited = UpdateIsSocialMediaStepVisited.request;

const CLEAR_CREATED_QUICK_LINK_NAMESPACE = 'CLEAR_CREATED_QUICK_LINK' as const;
const ClearCreatedQuickLink = new ReduxAsyncAction(CLEAR_CREATED_QUICK_LINK_NAMESPACE);
ClearCreatedQuickLink.registerRequest(async () => {
  return {
    createQuickLink: undefined,
  };
});

export const CLEAR_CREATED_QUICK_LINK: ActionNamespaceConstants<typeof CLEAR_CREATED_QUICK_LINK_NAMESPACE> =
  ClearCreatedQuickLink.constants;
export const clearCreatedQuickLink = ClearCreatedQuickLink.request;

const CLEAR_SELECTED_QUICK_LINK_NAMESPACE = 'CLEAR_SELECTED_QUICK_LINK' as const;
const ClearSelectedQuickLink = new ReduxAsyncAction(CLEAR_SELECTED_QUICK_LINK_NAMESPACE);
ClearSelectedQuickLink.registerRequest(async () => {
  return {
    selectedQuickLink: undefined,
  };
});

export const CLEAR_SELECTED_QUICK_LINK: ActionNamespaceConstants<typeof CLEAR_SELECTED_QUICK_LINK_NAMESPACE> =
  ClearSelectedQuickLink.constants;
export const clearSelectedQuickLink = ClearSelectedQuickLink.request;

const UPDATE_SELECTED_TEMPLATE_NAMESPACE = 'UPDATE_SELECTED_TEMPLATE' as const;
const UpdateSelectedTemplate = new ReduxAsyncAction(UPDATE_SELECTED_TEMPLATE_NAMESPACE);
UpdateSelectedTemplate.registerRequest(async (selectedTemplate: IQuickLinkTemplate) => {
  return { selectedTemplate };
});

export const UPDATE_SELECTED_TEMPLATE: ActionNamespaceConstants<typeof UPDATE_SELECTED_TEMPLATE_NAMESPACE> =
  UpdateSelectedTemplate.constants;
export const updateSelectedTemplate = UpdateSelectedTemplate.request;

const UPDATE_TITLE_NAMESPACE = 'UPDATE_TITLE' as const;
const UpdateTitle = new ReduxAsyncAction(UPDATE_TITLE_NAMESPACE);
UpdateTitle.registerRequest(async (title: string) => {
  return { title };
});

export const UPDATE_TITLE: ActionNamespaceConstants<typeof UPDATE_TITLE_NAMESPACE> = UpdateTitle.constants;
export const updateTitle = UpdateTitle.request;

const UPDATE_ALIAS_NAMESPACE = 'UPDATE_ALIAS' as const;
const UpdateAlias = new ReduxAsyncAction(UPDATE_ALIAS_NAMESPACE);
UpdateAlias.registerRequest(async (alias: string) => {
  return { alias };
});

export const UPDATE_ALIAS: ActionNamespaceConstants<typeof UPDATE_ALIAS_NAMESPACE> = UpdateAlias.constants;
export const updateAlias = UpdateAlias.request;

const UPDATE_ORIGINAL_WEB_URL_NAMESPACE = 'UPDATE_ORIGINAL_WEB_URL' as const;
const UpdateOriginalWebUrl = new ReduxAsyncAction(UPDATE_ORIGINAL_WEB_URL_NAMESPACE);
UpdateOriginalWebUrl.registerRequest(async (originalWebUrl: string) => {
  return { originalWebUrl };
});

export const UPDATE_ORIGINAL_WEB_URL: ActionNamespaceConstants<typeof UPDATE_ORIGINAL_WEB_URL_NAMESPACE> =
  UpdateOriginalWebUrl.constants;
export const updateOriginalWebUrl = UpdateOriginalWebUrl.request;

const UPDATE_FEATURE_NAMESPACE = 'UPDATE_FEATURE' as const;
const UpdateFeature = new ReduxAsyncAction(UPDATE_FEATURE_NAMESPACE);
UpdateFeature.registerRequest(async (feature: Option) => {
  return { feature };
});

export const UPDATE_FEATURE: ActionNamespaceConstants<typeof UPDATE_FEATURE_NAMESPACE> = UpdateFeature.constants;
export const updateFeature = UpdateFeature.request;

const UPDATE_CHANNEL_NAMESPACE = 'UPDATE_CHANNEL' as const;
const UpdateChannel = new ReduxAsyncAction(UPDATE_CHANNEL_NAMESPACE);
UpdateChannel.registerRequest(async (channel: Option) => {
  return { channel };
});

export const UPDATE_CHANNEL: ActionNamespaceConstants<typeof UPDATE_CHANNEL_NAMESPACE> = UpdateChannel.constants;
export const updateChannel = UpdateChannel.request;

const UPDATE_CAMPAIGN_NAMESPACE = 'UPDATE_CAMPAIGN' as const;
const UpdateCampaign = new ReduxAsyncAction(UPDATE_CAMPAIGN_NAMESPACE);
UpdateCampaign.registerRequest(async (campaign: Option) => {
  return { campaign };
});

export const UPDATE_CAMPAIGN: ActionNamespaceConstants<typeof UPDATE_CAMPAIGN_NAMESPACE> = UpdateCampaign.constants;
export const updateCampaign = UpdateCampaign.request;

const UPDATE_TAGS_NAMESPACE = 'UPDATE_TAGS' as const;
const UpdateTags = new ReduxAsyncAction(UPDATE_TAGS_NAMESPACE);
UpdateTags.registerRequest(async (tags: Option | Option[]) => {
  return { tags };
});

export const UPDATE_TAGS: ActionNamespaceConstants<typeof UPDATE_TAGS_NAMESPACE> = UpdateTags.constants;
export const updateTags = UpdateTags.request;

const UPDATE_IOS_REDIRECT_NAMESPACE = 'UPDATE_IOS_REDIRECT' as const;
const UpdateIosRedirect = new ReduxAsyncAction(UPDATE_IOS_REDIRECT_NAMESPACE);
UpdateIosRedirect.registerRequest(async (iosRedirect: Redirect) => {
  return { iosRedirect };
});

export const UPDATE_IOS_REDIRECT: ActionNamespaceConstants<typeof UPDATE_IOS_REDIRECT_NAMESPACE> =
  UpdateIosRedirect.constants;
export const updateIosRedirect = UpdateIosRedirect.request;

const UPDATE_ANDROID_REDIRECT_NAMESPACE = 'UPDATE_ANDROID_REDIRECT' as const;
const UpdateAndroidRedirect = new ReduxAsyncAction(UPDATE_ANDROID_REDIRECT_NAMESPACE);
UpdateAndroidRedirect.registerRequest(async (androidRedirect: Redirect) => {
  return { androidRedirect };
});

export const UPDATE_ANDROID_REDIRECT: ActionNamespaceConstants<typeof UPDATE_ANDROID_REDIRECT_NAMESPACE> =
  UpdateAndroidRedirect.constants;
export const updateAndroidRedirect = UpdateAndroidRedirect.request;

const UPDATE_DESKTOP_REDIRECT_NAMESPACE = 'UPDATE_DESKTOP_REDIRECT' as const;
const UpdateDesktopRedirect = new ReduxAsyncAction(UPDATE_DESKTOP_REDIRECT_NAMESPACE);
UpdateDesktopRedirect.registerRequest(async (desktopRedirect: Redirect) => {
  return { desktopRedirect };
});

export const UPDATE_DESKTOP_REDIRECT: ActionNamespaceConstants<typeof UPDATE_DESKTOP_REDIRECT_NAMESPACE> =
  UpdateDesktopRedirect.constants;
export const updateDesktopRedirect = UpdateDesktopRedirect.request;

const UPDATE_IOS_NAMESPACE = 'UPDATE_IOS' as const;
const UpdateIos = new ReduxAsyncAction(UPDATE_IOS_NAMESPACE);
UpdateIos.registerRequest(async (ios: string | Option) => {
  return { ios };
});

export const UPDATE_IOS: ActionNamespaceConstants<typeof UPDATE_IOS_NAMESPACE> = UpdateIos.constants;
export const updateIos = UpdateIos.request;

const UPDATE_ANDROID_NAMESPACE = 'UPDATE_ANDROID' as const;
const UpdateAndroid = new ReduxAsyncAction(UPDATE_ANDROID_NAMESPACE);
UpdateAndroid.registerRequest(async (android: string | Option) => {
  return { android };
});

export const UPDATE_ANDROID: ActionNamespaceConstants<typeof UPDATE_ANDROID_NAMESPACE> = UpdateAndroid.constants;
export const updateAndroid = UpdateAndroid.request;

const UPDATE_DESKTOP_NAMESPACE = 'UPDATE_DESKTOP' as const;
const UpdateDesktop = new ReduxAsyncAction(UPDATE_DESKTOP_NAMESPACE);
UpdateDesktop.registerRequest(async (desktop: string | Option) => {
  return { desktop };
});

export const UPDATE_DESKTOP: ActionNamespaceConstants<typeof UPDATE_DESKTOP_NAMESPACE> = UpdateDesktop.constants;
export const updateDesktop = UpdateDesktop.request;

const UPDATE_WEB_ONLY_LINK_NAMESPACE = 'UPDATE_WEB_ONLY_LINK' as const;
const UpdateWebOnlyLink = new ReduxAsyncAction(UPDATE_WEB_ONLY_LINK_NAMESPACE);
UpdateWebOnlyLink.registerRequest(async (webOnlyLink: boolean) => {
  return { webOnlyLink };
});

export const UPDATE_WEB_ONLY_LINK: ActionNamespaceConstants<typeof UPDATE_WEB_ONLY_LINK_NAMESPACE> =
  UpdateWebOnlyLink.constants;
export const updateWebOnlyLink = UpdateWebOnlyLink.request;

const SEARCH_IOS_APP_NAME_NAMESPACE = 'SEARCH_IOS_APP_NAME' as const;
const SearchIosAppName = new ReduxAsyncAction(SEARCH_IOS_APP_NAME_NAMESPACE);
SearchIosAppName.registerRequest(async (appId: string) => {
  const appIdWithoutIdPrefix = appId.slice(2);

  const response = await fetch(`https://itunes.apple.com/lookup?id=${appIdWithoutIdPrefix}&country=no`, {
    method: 'POST',
  });

  const data = await response.json();

  const iosAppName = data?.results[0]?.trackName;

  return { iosAppName };
});

export const SEARCH_IOS_APP_NAME: ActionNamespaceConstants<typeof SEARCH_IOS_APP_NAME_NAMESPACE> =
  SearchIosAppName.constants;
export const searchIosAppName = SearchIosAppName.request;

const SEARCH_ANDROID_APP_NAME_NAMESPACE = 'SEARCH_ANDROID_APP_NAME' as const;
const SearchAndroidAppName = new ReduxAsyncAction(SEARCH_ANDROID_APP_NAME_NAMESPACE);
SearchAndroidAppName.registerRequest(async (packageSlug: string) => {
  const data = await server('google play load', { value: packageSlug });

  const androidAppName = data.text;

  return { androidAppName };
});

export const SEARCH_ANDROID_APP_NAME: ActionNamespaceConstants<typeof SEARCH_ANDROID_APP_NAME_NAMESPACE> =
  SearchAndroidAppName.constants;
export const searchAndroidAppName = SearchAndroidAppName.request;

const UPDATE_LINK_DATA_NAMESPACE = 'UPDATE_LINK_DATA' as const;
const UpdateLinkData = new ReduxAsyncAction(UPDATE_LINK_DATA_NAMESPACE);
UpdateLinkData.registerRequest(async (linkData: Record<string, any>) => {
  return { linkData };
});

export const UPDATE_LINK_DATA: ActionNamespaceConstants<typeof UPDATE_LINK_DATA_NAMESPACE> = UpdateLinkData.constants;
export const updateLinkData = UpdateLinkData.request;

const UPDATE_IS_BLACKLIST_ERROR_NAMESPACE = 'UPDATE_IS_BLACKLIST_ERROR' as const;
const UpdateIsBlacklistError = new ReduxAsyncAction(UPDATE_IS_BLACKLIST_ERROR_NAMESPACE);
UpdateIsBlacklistError.registerRequest(async (isBlacklistError: boolean) => {
  return { isBlacklistError };
});

export const UPDATE_IS_BLACKLIST_ERROR: ActionNamespaceConstants<typeof UPDATE_IS_BLACKLIST_ERROR_NAMESPACE> =
  UpdateIsBlacklistError.constants;
export const updateIsBlacklistError = UpdateIsBlacklistError.request;

const UPDATE_SOCIAL_TITLE_NAMESPACE = 'UPDATE_SOCIAL_TITLE' as const;
const UpdateSocialTitle = new ReduxAsyncAction(UPDATE_SOCIAL_TITLE_NAMESPACE);
UpdateSocialTitle.registerRequest(async (socialTitle: string) => {
  return { socialTitle };
});

export const UPDATE_SOCIAL_TITLE: ActionNamespaceConstants<typeof UPDATE_SOCIAL_TITLE_NAMESPACE> =
  UpdateSocialTitle.constants;
export const updateSocialTitle = UpdateSocialTitle.request;

const UPDATE_QR_CODE_SETTINGS_NAMESPACE = 'UPDATE_QR_CODE_SETTINGS' as const;
const UpdateQrCodeSettings = new ReduxAsyncAction(UPDATE_QR_CODE_SETTINGS_NAMESPACE);
UpdateQrCodeSettings.registerRequest(async (qrCodeSettings: QrCodeSettings) => {
  return { qrCodeSettings };
});

export const UPDATE_QR_CODE_SETTINGS: ActionNamespaceConstants<typeof UPDATE_QR_CODE_SETTINGS_NAMESPACE> =
  UpdateQrCodeSettings.constants;
export const updateQrCodeSettings = UpdateQrCodeSettings.request;

const UPDATE_SOCIAL_DESCRIPTION_NAMESPACE = 'UPDATE_SOCIAL_DESCRIPTION' as const;
const UpdateSocialDescription = new ReduxAsyncAction(UPDATE_SOCIAL_DESCRIPTION_NAMESPACE);
UpdateSocialDescription.registerRequest(async (socialDescription: string) => {
  return { socialDescription };
});

export const UPDATE_SOCIAL_DESCRIPTION: ActionNamespaceConstants<typeof UPDATE_SOCIAL_DESCRIPTION_NAMESPACE> =
  UpdateSocialDescription.constants;
export const updateSocialDescription = UpdateSocialDescription.request;

const UPDATE_SOCIAL_IMAGE_NAMESPACE = 'UPDATE_SOCIAL_IMAGE' as const;
const UpdateSocialImage = new ReduxAsyncAction(UPDATE_SOCIAL_IMAGE_NAMESPACE);
UpdateSocialImage.registerRequest(async (socialImage: string) => {
  return { socialImage };
});

export const UPDATE_SOCIAL_IMAGE: ActionNamespaceConstants<typeof UPDATE_SOCIAL_IMAGE_NAMESPACE> =
  UpdateSocialImage.constants;
export const updateSocialImage = UpdateSocialImage.request;

const CREATE_QUICK_LINK_NAMESPACE = 'CREATE_QUICK_LINK' as const;
const CreateQuickLink = new ReduxAsyncAction(CREATE_QUICK_LINK_NAMESPACE);
CreateQuickLink.registerRequest(
  async (domain: string, quickLink: QuickLinkCreatorReducerType, selectedTemplate?: IQuickLinkTemplate) => {
    try {
      const payload = QuickLinkCreatorService.getQuickLinkPayload(domain, quickLink);
      const templateId = selectedTemplate?.id;
      const templatePath = templateId ? `/template/${templateId}` : '';

      const response = await dash_api.post(`/v1/linkhub/quick${templatePath}`, payload);

      return { createdQuickLink: response.data };
    } catch (error) {
      NotificationActions.showNotification('Failed to create quick link.', 'error');

      throw error;
    }
  }
);

export const CREATE_QUICK_LINK: ActionNamespaceConstants<typeof CREATE_QUICK_LINK_NAMESPACE> = CreateQuickLink.constants;
export const createQuickLink = CreateQuickLink.request;

const FETCH_QUICK_LINK_TEMPLATE_NAMESPACE = 'FETCH_QUICK_LINK_TEMPLATE' as const;
const FetchQuickLinkTemplate = new ReduxAsyncAction(FETCH_QUICK_LINK_TEMPLATE_NAMESPACE);
FetchQuickLinkTemplate.registerRequest(async (templateId: string) => {
  try {
    const selectedTemplate = await dash_api.get(`/v1/linkhub/quick-link-templates/${templateId}`);

    return { selectedTemplate: selectedTemplate?.data };
  } catch (error) {
    NotificationActions.showNotification('Failed to fetch template.', 'error');

    throw error;
  }
});

export const FETCH_QUICK_LINK_TEMPLATE: ActionNamespaceConstants<typeof FETCH_QUICK_LINK_TEMPLATE_NAMESPACE> =
  FetchQuickLinkTemplate.constants;
export const fetchQuickLinkTemplate = FetchQuickLinkTemplate.request;

const UPDATE_IS_EDITING_NAMESPACE = 'UPDATE_IS_EDITING' as const;
const UpdateIsEditing = new ReduxAsyncAction(UPDATE_IS_EDITING_NAMESPACE);
UpdateIsEditing.registerRequest(async (isEditing: boolean) => {
  return { isEditing };
});

export const UPDATE_IS_EDITING: ActionNamespaceConstants<typeof UPDATE_IS_EDITING_NAMESPACE> = UpdateIsEditing.constants;
export const updateIsEditing = UpdateIsEditing.request;

const UPDATE_SELECTED_QUICK_LINK_NAMESPACE = 'UPDATE_SELECTED_QUICK_LINK' as const;
const UpdateSelectedQuickLink = new ReduxAsyncAction(UPDATE_SELECTED_QUICK_LINK_NAMESPACE);
UpdateSelectedQuickLink.registerRequest(async (selectedQuickLink: Record<string, any>) => {
  return { selectedQuickLink };
});

export const UPDATE_SELECTED_QUICK_LINK: ActionNamespaceConstants<typeof UPDATE_SELECTED_QUICK_LINK_NAMESPACE> =
  UpdateSelectedQuickLink.constants;
export const updateSelectedQuickLink = UpdateSelectedQuickLink.request;

const FETCH_QUICK_LINK_NAMESPACE = 'FETCH_QUICK_LINK' as const;
const FetchQuickLink = new ReduxAsyncAction(FETCH_QUICK_LINK_NAMESPACE);
FetchQuickLink.registerRequest(async (quickLinkId: string) => {
  try {
    const { data } = await dash_api.get('/v1/link/marketing/single', { params: { id: quickLinkId } });

    return QuickLinkEditorService.getQuickLinkPayload(data);
  } catch (error) {
    NotificationActions.showNotification('Failed to fetch quick link.', 'error');
    throw error;
  }
});

export const FETCH_QUICK_LINK: ActionNamespaceConstants<typeof FETCH_QUICK_LINK_NAMESPACE> = FetchQuickLink.constants;
export const fetchQuickLink = FetchQuickLink.request;

const UPDATE_EDITED_QUICK_LINK_NAMESPACE = 'UPDATE_EDITED_QUICK_LINK' as const;
const UpdateEditedQuickLink = new ReduxAsyncAction(UPDATE_EDITED_QUICK_LINK_NAMESPACE);
UpdateEditedQuickLink.registerRequest(
  async (
    quickLinkId: string,
    domain: string,
    quickLink: QuickLinkCreatorReducerType,
    selectedTemplate?: IQuickLinkTemplate
  ) => {
    try {
      const payload = QuickLinkCreatorService.getQuickLinkPayload(domain, quickLink);
      const templateId = selectedTemplate?.id;
      const templatePath = templateId ? `/template/${templateId}` : '';

      const response = await dash_api.put(`/v1/linkhub/quick/${quickLinkId}${templatePath}`, payload);

      return { editedQuickLink: response.data };
    } catch (error) {
      NotificationActions.showNotification('Failed to edit quick link.', 'error');

      throw error;
    }
  }
);

export const UPDATE_EDITED_QUICK_LINK: ActionNamespaceConstants<typeof UPDATE_EDITED_QUICK_LINK_NAMESPACE> =
  UpdateEditedQuickLink.constants;
export const updateEditedQuickLink = UpdateEditedQuickLink.request;

const BULK_CREATE_QUICK_LINKS_NAMESPACE = 'BULK_CREATE_QUICK_LINKS' as const;
const BulkCreateQuickLinks = new ReduxAsyncAction(BULK_CREATE_QUICK_LINKS_NAMESPACE);
BulkCreateQuickLinks.registerRequest(async (templateId: string, links: IQuickLink[], collectionName?: string) => {
  try {
    const requestData = collectionName ? { templateId, links, collectionName } : { templateId, links };
    const { data } = await dash_api.post('/v1/linkhub/quick/bulk', requestData);
    return { data };
  } catch (error) {
    NotificationActions.showNotification('Failed to bulk create quick links.', 'error');
    throw error;
  }
});
export const BULK_CREATE_QUICK_LINKS: ActionNamespaceConstants<typeof BULK_CREATE_QUICK_LINKS_NAMESPACE> =
  BulkCreateQuickLinks.constants;
export const bulkCreateQuickLinks = BulkCreateQuickLinks.request;

const FETCH_QUICK_LINK_COLLECTIONS_NAMESPACE = 'FETCH_QUICK_LINK_COLLECTIONS' as const;
const FetchQuickLinkCollections = new ReduxAsyncAction(FETCH_QUICK_LINK_COLLECTIONS_NAMESPACE);
FetchQuickLinkCollections.registerRequest(async () => {
  try {
    const response = await dash_api.get('/v1/linkhub/collections?type=quick');
    return {
      quickLinkCollections: response?.data,
    };
  } catch (error) {
    NotificationActions.showNotification('Failed to fetch quick link collections.', 'error');

    throw error;
  }
});

export const FETCH_QUICK_LINK_COLLECTIONS: ActionNamespaceConstants<typeof FETCH_QUICK_LINK_COLLECTIONS_NAMESPACE> =
  FetchQuickLinkCollections.constants;
export const fetchQuickLinkCollections = FetchQuickLinkCollections.request;
